import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDevices = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.333 9.333c0-0.733 0.6-1.333 1.333-1.333h21.333c0.733 0 1.333-0.6 1.333-1.333s-0.6-1.333-1.333-1.333h-22.667c-1.467 0-2.667 1.2-2.667 2.667v14.667h-0.667c-1.107 0-2 0.893-2 2s0.893 2 2 2h16.667v-4h-13.333v-13.333zM30.667 10.667h-8c-0.733 0-1.333 0.6-1.333 1.333v13.333c0 0.733 0.6 1.333 1.333 1.333h8c0.733 0 1.333-0.6 1.333-1.333v-13.333c0-0.733-0.6-1.333-1.333-1.333zM29.333 22.667h-5.333v-9.333h5.333v9.333z" })
});
export default SvgDevices;
